import React from "react";
import { ILoginModalProps } from "./LoginModalProps";
import { useSelector } from "react-redux";
import { StyledLoginForm, StyledModal } from "./LoginModalHelpers";
import { Button, Modal } from "react-bootstrap";
import { TravelPassLogo } from "../SignInBar/SignInBarHelpers";
import { useLoginModalSliceContext } from "../../../context/SliceContexts/LoginModalContext";

const LoginModal: React.FC<ILoginModalProps> = () => {
  const member = useSelector((state: any) => state.member);
  const {
    show,
    onHide,
    welcomeSubHeading,
    location,
    isEditReservation,
    isFrom,
  } = useLoginModalSliceContext();
  if (member.isLoggedIn && show) {
    onHide();
    return <></>;
  }
  return (
    <>
      <StyledModal
        onHide={onHide}
        welcomeSubHeading={welcomeSubHeading}
        location={location}
        isEditReservation={isEditReservation}
        isFrom={isFrom}
        show={show}
        centered
        size="lg"
        aria-label="Travel Pass Login"
      >
        <Modal.Header closeButton>
          <Modal.Title className={`w-100 text-center`}>
            <div className="icon">
              <TravelPassLogo />
              {/* <span>simply rewarding</span> */}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <StyledLoginForm
            onHide={onHide}
            welcomeSubHeading={
              welcomeSubHeading ||
              "Sign In To Travel Pass to Complete this Reservation"
            }
            location={location}
            isEditReservation={isEditReservation}
            isFrom={isFrom}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            size="sm"
            onClick={onHide}
            id="continue-without-signin"
          >
            Continue without Signing In
          </Button>
        </Modal.Footer>
      </StyledModal>
    </>
  );
};

export default LoginModal;
